import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { IPlacementTestClass } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { IClassroom } from 'src/app/interfaces/enrollment';
import { EnrollmentStore } from 'src/app/stores/enrollment/enrollment.store';
import { utc } from 'moment';
import { MappingService } from 'src/app/services/mapping.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-add-classroom',
  templateUrl: './add-classroom.component.html',
  styleUrls: ['./add-classroom.component.scss']
})
export class AddClassroomComponent implements OnInit {

  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add classroom"

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  shortname: AbstractControl;
  classlevel: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  CLASS_LIST: any;


  constructor(
    public dialogRef: MatDialogRef<AddClassroomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: EnrollmentStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }
  
  displayItem(item: any): string {
    return item ? item.name : item;
  }
  
  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      description: [null],
      // order: [null],
      shortname: [null],
      classlevel: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
    })
    this.classlevel = this.form.controls['classlevel']
    const class_list = await this.store.fetchListArray(COLLECTION_NAME.GENERAL_PLACEMENT_TEST, "name");

    this.CLASS_LIST = MappingService.autoComplete(this.classlevel, class_list, "name");

    const { ITEM } = this.data;
    if (ITEM) {
      this.TITLE = "Edit class";
      const { name, description, CLASS_LIST, shortname } = ITEM;
      this.form.patchValue({
        name, description, CLASS_LIST, shortname
      })
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { selectedCompanyKey, user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { name, description, shortname, classlevel} = f;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: IClassroom = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`.trim()),
        organizationRef: null,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: `${name}`.trim() || null,
        description: description || null,
        shortname: shortname || null,
        classKey: classlevel.key,
        classRef: this.ds.generalPlacementTestRef().doc(classlevel.key).ref,
      }

      this.store.save(item, (success, res) => {
        if (success) {
          this.snackBar.open("Class has been created successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}
